import {StyleSheet, View} from "@react-pdf/renderer";
import {StaffTableHeader} from "./StaffTableHeader";
import {StaffTableRow} from "./StaffTableRow";
import {HSZG_MAIN_COLOR} from "../../../../config/style/colors";

const styles = StyleSheet.create({
    tableContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        borderWidth: 1.5,
        borderColor: HSZG_MAIN_COLOR,
    },
});

export const StaffPdfTable = (props) => {
    return (
        <View style={styles.tableContainer}>
            <StaffTableHeader/>
            <StaffTableRow rows={props.rows}/>
        </View>
    );
}

